import { jsx as _jsx } from "react/jsx-runtime";
import { useSelector } from 'react-redux';
import { toastsSelector } from '@models/toast/selectors';
import Toast from './Toast/Toast';
import classes from './Toasts.module.scss';
const Toasts = () => {
    const toasts = useSelector(toastsSelector);
    return (_jsx("div", { className: classes.container, children: toasts.map(({ variant, text, id }) => (_jsx(Toast, { variant: variant, text: text, id: id }, id))) }));
};
export default Toasts;
